import * as types from '../actions/actionTypes'

import initialState from './initialState'

const mergeIntegrationsByType = (existingIntegrations, updatedIntegrations) => {
  const updatedTypes = updatedIntegrations.map((integration) => integration.type)
  const untouched = existingIntegrations.filter((integration) => !updatedTypes.includes(integration.type))

  return [...untouched, ...updatedIntegrations]
}

export const integrationsReducer = (state = initialState.integrations, action) => {
  switch (action.type) {
    case types.FETCH_INTEGRATIONS_FAILURE:
      return { ...state, appIntegrations: [] }
    case types.FETCH_INTEGRATIONS_SUCCESS:
      return { ...state, appIntegrations: action.payload }
    case types.DISCONNECT_SLACK_SUCCESS:
    case types.DISCONNECT_GOOGLE_CALENDAR_SUCCESS:
      return { ...state, appIntegrations: mergeIntegrationsByType(state.appIntegrations, action.payload) }
    case types.DISCONNECT_SLACK_FAILURE:
    case types.DISCONNECT_GOOGLE_CALENDAR_FAILURE:
      return { ...state }
    default:
      return state
  }
}
